<template>
  <a
    class="d-follow-button button button-follow"
    :class="{
      'button-yellow': followData.isFollowing,
      'button-white-bordered-yellow': !followData.isFollowing && !isBlackButton,
      'button-black-bordered-yellow': isBlackButton,
      'button-sm': isSmallButton,
    }"
    :disabled="followData.isProcessing"
    @click.stop.prevent="follow()"
  >
    <span v-if="followData.isFollowing">Following</span>
    <span v-else>Follow</span>
  </a>
</template>

<script>
import Vue from 'vue';

import followersService from '@d-services/followers-service/followers-service';
import { getErrorMessage } from '@d-shared/utils/errors';

export default {
  props: {
    isFollowing: {
      type: Boolean,
      default: false,
    },
    userSlug: {
      type: String,
      required: true,
    },
    isSmallButton: {
      type: Boolean,
      default: false,
    },
    isBlackButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    storeData() {
      return this.$store.getters['Following/get-following-user'];
    },
    followData() {
      return this.storeData(this.userSlug) || {};
    },
  },
  mounted() {
    this.setInitialData();
  },
  methods: {
    async addFollow() {
      this.updateProcessing(true);

      try {
        await followersService.followUser(this.userSlug);
        this.updateIsFollowing(true);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          Vue.prototype.signupModal.show();
        } else {
          Vue.duiNotificationManager.error(getErrorMessage(error));
        }
      }

      Vue.prototype.eventsTracking.startNewChain('follow-user', { followingUuid: this.userSlug });

      this.updateProcessing(false);
    },

    async follow() {
      if (this.followData.isFollowing) {
        await this.removeFollow();
        return;
      }

      await this.addFollow();

      this.$emit('add-follow');
    },

    async removeFollow() {
      this.updateProcessing(true);

      try {
        await followersService.stopFollowingUser(this.userSlug);
        this.updateIsFollowing(false);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.updateProcessing(false);
    },

    setInitialData() {
      if (this.followData.isFollowing !== undefined) return;

      this.$store.dispatch('Following/updateFollowing', {
        slug: this.userSlug,
        isProcessing: false,
        isFollowing: this.isFollowing,
      });
    },

    updateProcessing(isProcessing) {
      this.$store.dispatch('Following/updateFollowing', {
        slug: this.userSlug,
        isProcessing,
        isFollowing: this.followData.isFollowing,
      });
    },

    updateIsFollowing(isFollowing) {
      this.$store.dispatch('Following/updateFollowing', {
        slug: this.userSlug,
        isProcessing: this.followData.isProcessing,
        isFollowing,
      });
    },
  },
};
</script>
